import { createSelector } from '@reduxjs/toolkit';

import { selectAppConfig } from '@/features/config/selectAppConfig';
import { selectUserProfile } from '@/features/user/selectUserProfile';

export const selectDateFormat = createSelector(
  [selectAppConfig, selectUserProfile],
  ({ systemDateFormat }, { initialized, dateFormat }) => (initialized ? dateFormat : systemDateFormat),
);
